import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const TeradataVantage = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="TeradataVantage"
    height={height}
    width={width}
    title="Teradata Vantage logo"
    titleId="teradata-vantage-logo-title"
    viewBox="0 0 297 297"
    {...props}
  >
    <circle cx="148.5" cy="148.5" r="148.5" fill="#FF5F02" />
    <g clipPath="url(#clip0_4041_582)">
      <path
        d="M91 178.273V70H123.107V99.7968H161.373V128.345H123.107V178.273C123.107 191.185 129.762 195.406 139.149 195.406H161.373V223.954H139.149C106.296 223.979 91 209.568 91 178.273Z"
        fill="white"
      />
      <path
        d="M174.931 209.818C174.931 200.377 182.331 192.934 191.965 192.934C201.6 192.934 209 200.377 209 209.818C209 219.259 201.352 226.951 191.965 226.951C182.579 226.951 174.931 219.259 174.931 209.818Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4041_582">
        <rect width="118" height="156.951" fill="white" transform="translate(91 70)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
